import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Image from 'src/components/image';
import PropTypes from 'prop-types';

const CandidateCaptures = ({ candidateCaptures }) => {
  // functions
  const getCandidateCaptureTime = seconds => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    return `${formattedMinutes}:${formattedSeconds}`;
  };

  return (
    <Accordion
      sx={{ padding: '0rem 1.2rem' }}
      disabled={!candidateCaptures.length}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <p
          style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            margin: '0px',
            padding: '0px',
          }}
        >
          Candidate&apos;s Images
        </p>
      </AccordionSummary>
      {candidateCaptures && candidateCaptures.length ? (
        <AccordionDetails>
          <Stack
            sx={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              gap: '1rem',
            }}
          >
            {candidateCaptures.map((candidateCapture, index) => (
              <Paper
                key={index}
                sx={{
                  mr: 3,
                  borderRadius: 1,
                  position: 'relative',
                }}
              >
                <Stack alignItems="center" sx={{ pb: 0.5 }}>
                  <Image
                    src={candidateCapture.image_url}
                    sx={{ width: 150, height: 100, borderRadius: 1.5 }}
                    alt="image"
                  />
                  <Typography>
                    {getCandidateCaptureTime(candidateCapture.interview_time)}
                  </Typography>
                </Stack>
              </Paper>
            ))}
          </Stack>
        </AccordionDetails>
      ) : null}
    </Accordion>
  );
};

CandidateCaptures.propTypes = {
  candidateCaptures: PropTypes.array,
};
export default CandidateCaptures;
